<template>
  <div class="broker-system">
    <div class="date-select-cont clearfix">
      <c-calendar
        v-if="startTime"
        class="date-selecter"
        width="120px"
        name="start-time"
        :value="startTime"
        :futureDayHide="endTimeNum"
        :promptText="startTimeText"
        @onChanges="setStartTime"
        inputLineStyle="c-1-bd"
        dateInfoTilteClass="f-8-cl"
      />
      <c-calendar
        v-if="endTime"
        class="date-selecter"
        width="120px"
        name="end-time"
        :value="endTime"
        :agoDayHide="startTimeNum"
        :promptText="endTimeText"
        @onChanges="setEndTime"
        inputLineStyle="c-1-bd"
        dateInfoTilteClass="f-8-cl"
      />
      <!-- <c-select :promptText="$t('brokerSystem.otherText[5]')"
        class="date-selecter"
        :value="level"
        :options="personTypeList"
        :errorHave="true"
        width="140px"
        :filterable="true"
        @onChanges="levelChange"/> -->
      <c-inputLine
        class="date-selecter input"
        maxLength="20"
        name="uidValue"
        :promptText="$t('brokerSystem.lowerTable[11]')"
        :errorHave="true"
        :errorText="$t('login.formatIncorrect')"
        marginTop="0px"
        :value="uidValue"
        inputType="text"
        @onchanges="inputChanges"
        :isLogin="true"
      />
      <c-select :promptText="$t('brokerSystem.otherText[3]')"
        class="date-selecter"
        :value="returnStatus"
        :options="returnStatusList"
        :errorHave="true"
        width="140px"
        :filterable="true"
        @onChanges="statusChange"/>
    </div>
    <c-table
      :imgMap="imgMap"
      :colorMap="colorMap"
      :loading="loading"
      :classes="classes"
      :headClasses="headClasses"
      :bodyClasses="bodyClasses"
      :lineClasses="lineClass"
      :columns="columns"
      :dataList="dataList"
      :lineNumber="lineNumber"
      :cellHeight="cellHeight"
      :headHeight="headHeight"
    />
    <div class="pagination">
      <div>
        <c-pagination
          v-if="(count/pageSize) > 1"
          :total="count"
          :current-page="page"
          :display="pageSize"
          classes="a-5-bg"
          @pagechange="pagechange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import mixin from 'BlockChain-ui-privatization/PC/common-mixin/personal/brokerSystem/lowerInfoRebate/lowerInfoRebate';
import 'BlockChain-ui-privatization/PC/common-mixin/personal/brokerSystem/lowerInfoRebate/lowerInfoRebate.styl';

export default {
  mixins: [mixin],
  mounted() {
    this.init();
  },
};
</script>
